// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "wrapper-3fK7B";
var _5 = "header-LREhH";
var _6 = "cities-2hra5";
var _7 = "plane__icon-1WeY2";
var _8 = "city-36yGG";
var _9 = "city__airport-u2_0d";
var _a = "city__info-1bR7P";
var _b = "city__iata-3KQRn";
var _c = "city__time-3rdMD";
var _d = "flightInfo-3cuwU";
var _e = "flightInfo__item-3_KwC";
var _f = "flightInfo__title-2L8TZ";
var _10 = "flightInfo__value-_TFaP";
var _11 = "flightInfo__valueBold-2Gybn";
var _12 = "footer-2kSGa";
var _13 = "footer__airline-2I1YS";
var _14 = "airline__logo-3HpWN";
var _15 = "airline__name-3qTsC";
var _16 = "footerItems-1MS4A";
var _17 = "footerItems__item-3fAaS";
var _18 = "footerItems__title-WmfcU";
var _19 = "footerItems__value-2Z0BI";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "wrapper", _5 as "header", _6 as "cities", _7 as "plane__icon", _8 as "city", _9 as "city__airport", _a as "city__info", _b as "city__iata", _c as "city__time", _d as "flightInfo", _e as "flightInfo__item", _f as "flightInfo__title", _10 as "flightInfo__value", _11 as "flightInfo__valueBold", _12 as "footer", _13 as "footer__airline", _14 as "airline__logo", _15 as "airline__name", _16 as "footerItems", _17 as "footerItems__item", _18 as "footerItems__title", _19 as "footerItems__value" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "wrapper": _4, "header": _5, "cities": _6, "plane__icon": _7, "city": _8, "city__airport": _9, "city__info": _a, "city__iata": _b, "city__time": _c, "flightInfo": _d, "flightInfo__item": _e, "flightInfo__title": _f, "flightInfo__value": _10, "flightInfo__valueBold": _11, "footer": _12, "footer__airline": _13, "airline__logo": _14, "airline__name": _15, "footerItems": _16, "footerItems__item": _17, "footerItems__title": _18, "footerItems__value": _19 }
